const dev = {
  apiUrl: process.env.REACT_APP_BACKEND_API_URL,

  nodeApiUrl: process.env.REACT_APP_NODE_BACKEND_API_URL,

  // auth
  auth: {
    login: "/users/rest-auth/login/",
    signup: "/users/rest-auth/registration/",
    resetPassword: "/users/password-reset/",
    resetPasswordConfirm: "/users/password-reset-confirm/",
    logout: "/users/rest-auth/logout/",
    selectRole: "/users/set-user-role/",
    googleLogin: "/users/rest-auth/google/",
    microsoftLogin: "/users/rest-auth/microsoft/",
    onBoard: "/users/user-details/",
    loggedInUser: "/users/logged-in-user/",
    timezone: "/users/set-user-timezone/",
    invitePasswordReset: "/users/invite-password-reset/",
  },

  oneSignal: {
    oneSignalRegister: "/notifications/onesignal-register/",
  },

  search: {
    search: "/search-api/search/",
  },

  //company
  company: {
    createCompany: "/users/set-company/",
    companyDetails: "/users/set-company/:id/",
  },

  // hiring manager
  hiringManager: {
    mentorApplication: "/notifications/mentor-application-notifications/",
    jobsList: "/jobs/job-list/",
    createJob: "/jobs/job-post/",
    updateJob: "/jobs/job-post/:id/",
    jobDetail: "/jobs/job-detail/:id/",
    kanboardJobDetail: "/jobs/job-application-detail/:id/",
    kanboardApplicantStatusUpdate: "/jobs/applicant-profile/:id/",
    acceptRejectMentor: "/hiring-manager/mentors-application-status/:id/",
    allMentorsApplied: "/jobs/job-application-all-mentors/:id/",

    applicantProfile: "/jobs/applicant-profile/:id/",
    applicantSubmittedAssessmentKits:
      "/interview/submitted-assessmentkits-list/:id/",
    getHiringProgressDetails: "/jobs/hiring-progress/:id/",
    createHiringProgress: "/jobs/hiring-progress/",
    updateHiringProgress: "/jobs/hiring-progress/update/:id/",
    createApplicantJobOffer: "/jobs/job-offer/",
    appllicantJobOfferById: "/jobs/job-offer/:id/", // comments
    getCommentList: "/jobs/comments/",
    // getCommentList:"/jobs/comments/:id/:stage/",
    createComment: "/jobs/comment/create/",
    deleteComment: "/jobs/comment/:id/",
    updateComment: "/jobs/comment/:id/",

    allAddedSkills: "/jobs/hiring-manager-skills/",
    allSuggestedMentors: "/jobs/mentor-list-by-skills/",
    allSuggestedCandidates: "/jobs/candidate-list-by-skills/",
    getApplicantHmsVideos: "/hms/hms-room-applicant-videos/:id/",
    getAllAppliedMentor: "/jobs/all-applied-mentor-list/",
    getAllAppliedCandidates: "/jobs/all-applied-candidate-list/",
    getAllSharedBucketList: "/interview/assigned-bucket-lists/",
    favouriteCandidate: "/interview/favourite-candidate/",
    updateFavouriteCandidate: "/interview/favourite-candidate/:id/",
    deleteFavouriteCandidate: "/interview/favourite-candidate/:id/",
    getAllFavouriteCandidates: "/interview/favourite-candidate-list/",
  },

  candidate: {
    applyJob: "/candidate/job-apply/:id/",
    appliedJobs: "/candidate/candidate-applied-jobs/",
    appliedJobDetails: "/candidate/applied-job-detail/:id/",
    //candidate profile
    createCandidate: "/candidate/candidate-profile/",
    updateCandidateProfile: "/candidate/candidate-profile/",
    getCandidateProfileData: "/candidate/candidate-profile/",
    getCandidateIntroData: "/candidate/candidate-profile/",

    // candidate education
    getCandidateAllEducationData: "/candidate/candidate-education/all/",
    deleteCandidateEducationByIdData: "/candidate/candidate-education/:id/",
    createCandidateEducation: "/candidate/candidate-education/",
    getCandidateEducationByIdData: "/candidate/candidate-education/:id/",

    //candidate profession
    getCandidateAllProfessionalData:
      "/candidate/candidate-work-experience/all/",
    getCandidateExperienceByIdData: "/candidate/candidate-work-experience/:id/",
    createCandidateExperience: "/candidate/candidate-work-experience/",
    deleteCandidateExperienceByIdData:
      "/candidate/candidate-work-experience/:id/",

    //candidate profession
    getCandidateAllSkillsData: "/candidate/candidate-skill/all/",
    createCandidateSkill: "/candidate/candidate-skill/",
    deleteCandidateSkillById: "/candidate/candidate-skill/:id/",

    //view assigned interview kit
    viewAssignedInterviewkitJob: "/interview/candidate-interview-kit/:id/",
    getInterviewKitQuestions: "/interview/interview-kit-questions/:id/",
    muxVideoUploadUrl: "/mux/mux-signed-url/",
    candidateInterviewVideo: "/interview/candidate-interview-video/",
    candidateReviewInterview: "/interview/review-interview-videos/:id/",
    muxUploadAssetPlayBackId: "/mux/mux-asset-playback-ids/:id/",
    submitRequestInterview: "/interview/request-live-interview/:id/",
    recentlyAssignedAssessmentKits:
      "/interview/candidate-assigned-assessment-kits/",
    acceptAssessmentKit: "/interview/candidate-accept-assessment-kit/:id/",
    acceptAssessmentKitDetails:
      "/interview/candidate-interview-kit-accept/:id/",
    getJobsLinkedWithAssignedAssessmentKit:
      "/interview/interview-kit-jobs-list/:id/",

    getAppliedJobsSummary: "/candidate/candidate-applied-job-count/",

    //candidate portfolio
    getCandidateAllPortfolioData: "/candidate/candidate-portfolio/all/",
    getCandidatePortfolioByIdData: "/candidate/candidate-portfolio/:id/",
    createCandidatePortfolio: "/candidate/candidate-portfolio/",
    deleteCandidatePortfolioByIdData: "/candidate/candidate-portfolio/:id/",
    updateCandidatePortfolio: "/candidate/candidate-portfolio/:id/",
    updateCandidateJobOffer: "/jobs/accept-job-offer/:id/",

    candidateInvitedJobsList: "/jobs/invited-jobs-list/",
    candidateSuggestedJobsList: "/candidate/suggested-jobs-candidate/",
    getCandidatePendingTask: "/candidate/candidate-pending-tasks/",
    getCandidateInterviewInvites: "/calendar/all-assigned-events-to-candidate/",
    getCandidateAcceptedInterviews: "/calendar/candidate-scheduled-interview/",
  },

  mentor: {
    mentorProfile: "/mentor/mentor-profile/",
    applyJob: "/mentor/mentor-job-apply/:id/",
    appliedJobs: "/mentor/mentor-applied-jobs/",
    appliedJobDetails: "/mentor/mentor-applied-job-detail/:id/",
    // candidate education
    getMentorAllEducationData: "/mentor/mentor-education/all/",
    deleteMentorEducationByIdData: "/mentor/mentor-education/:id/",
    createMentorEducation: "/mentor/mentor-education/",
    getMentorEducationByIdData: "/mentor/mentor-education/:id/",

    //mentor profession
    getMentorAllProfessionalData: "/mentor/mentor-work-experience/all/",
    getMentorExperienceByIdData: "/mentor/mentor-work-experience/:id/",
    createMentorExperience: "/mentor/mentor-work-experience/",
    deleteMentorExperienceByIdData: "/mentor/mentor-work-experience/:id/",

    //mentor skills
    getMentorAllSkillsData: "/mentor/mentor-skill/all/",
    createMentorSkill: "/mentor/mentor-skill/",
    deleteMentorSkillById: "/mentor/mentor-skill/:id/",

    // dashbard
    getMentorDashboard: "/mentor/mentor-dashboard/",
    getMentorKanbanboard: "/mentor/mentor-kanban-board/:id/:stage/",

    //INTERVIEW  kit
    createInterviewKit: "/interview/interview-kit/",
    getInterviewKit: "/interview/interview-kit/:id/",
    getAllPublishedInterviewKit: "/interview/published-interview-kit/",
    updateInterviewKit: "/interview/interview-kit/:id/",
    deleteInterviewKit: "/interview/interview-kit/:id/",
    getAllInterviewKit: "/interview/interview-kit-list/",
    updateInterviewKitTopic: "/interview/interview-kit-topic/:id/",
    updateInterviewKitTopicQuestion: "/interview/question/",
    updateInterviewQuestion: "/meet-room-question/<int:pk>/",

    //assign interview kit to job
    assignInterviewkitJob: "/interview/assign-interview-kit/:id/",
    getAssignedInterviewkitJob: "/interview/assigned-interview-kit/:id/",

    viewMentorProfile: "/jobs/applicant-mentor-profile/:id/",

    //mentor portfolio
    getMentorAllPortfolioData: "/mentor/mentor-portfolio/all/",
    getMentorPortfolioByIdData: "/mentor/mentor-portfolio/:id/",
    createMentorPortfolio: "/mentor/mentor-portfolio/",
    deleteMentorPortfolioByIdData: "/mentor/mentor-portfolio/:id/",
    updateMentorPortfolio: "/mentor/mentor-portfolio/:id/",
    // getSubmittedCandidatesInterview:
    //   "/interview/candidate-submitted-assessmentkits-list/:id/",
    getSubmittedCandidatesInterview:
      // "/interview/candidate-accepted-assessmentkits-list/:id/",
      "/interview/assessment-kit-assigned-candidates/:id/",
    assessmentKitQuestionRating: "/interview/assessment-kit-skill-rating/",
    assessmentKitQuestionRatingById:
      "/interview/assessment-kit-skill-rating/:id/",

    // bucket list
    createBucketList: "/interview/bucket-list-candidate/",
    getBucketList: "/interview/mentor-bucket-list/",
    deleteBucketList: "/interview/bucket-list-candidate/:id/",
    assignInterviewToKit: "/interview/assign-interviewkit-bucketlist/",
    viewBucketList: "/interview/bucket-list-detail/:id/",
    getBucketCandiatesList: "/interview/candidates-list-in-bucket/:id/",
    setBucketListByEmail: "/users/hiring-manager-invite-email/",

    // shortlisting
    shortListCandidate: "/interview/short-list-candidate/",
    deleteShortListedCandidate: "/interview/short-list-candidate/",
    getShortListedCandidatesByAssignmentKit:
      "/interview/short-list-candidates-list-interview-kit/",
    getShortListedCandidatesByJob:
      "/interview/short-list-candidates-list-job-posting/",
    addRemarkToKit: "/interview/interviewkit-remark/",
    getRemarkOfKit: "/interview/interviewkit-remark-list/:id/",
    updateShortlistedCandiate: "/interview/short-list-candidate/",
  },

  common: {
    //calendar
    storeGoogleCalendarToken: "/calendar-auth/google-token/",
    checkGoogleCalendarLinked: "/calendar-auth/is-google-calendar-linked/",
    getGoogleCalendarEventLists: "/calendar-auth/list-google-events/",
    getCalendarScheduledEventsTimings:
      "/calendar/mentor-scheduled-interview-timings/:id/",

    calendarEvent: "/calendar/event/",
    calendarEventById: "/calendar/event/:id/",
    calendarEventLists: "/calendar/all-events/",
    getCalendarEventLink: "/calendar/schedule-event-link/:id/",
    calendarEventAvailability: "/calendar/event-availability/",
    calendarEventAvailabilityById: "/calendar/event-availability/:id/",
    calendarAvailability: "/calendar/availability/",
    calendarAvailabilityById: "/calendar/availability/:id/",
    calendarAvailabilityLists: "/calendar/all-availability/",
    scheduledInterviewList: "/calendar/mentor-scheduled-interview/",
    upcomingScheduledInterviews: "/calendar/upcoming-scheduled-interview/",
    pastScheduledInterviews: "/calendar/past-scheduled-interview/",
    unregisteredUserScheduledInterviewList:
      "/calendar/user-unregistered-interview-schedule/",
    scheduledInterviewListByEvent:
      "/calendar/mentor-scheduled-interview-by-event/:id/",
    assignEventLinkToCandidate: "/calendar/assign-event-link-candidate/",
    assignedEventLinkToCandidateById:
      "/calendar/assign-event-link-candidate/:id/",
    assignedCandidatList: "/recruiter/assigned-candidates/",
    invitedCandidatList: "/jobs/invited-candidates-list-by-job/",

    //schedule interview
    requestScheduleInterview: "/calendar/interview-schedule/",
    requestScheduleInterviewById: "/calendar/interview-schedule/:id/",
    unregisteredUserRequestScheduleInterview:
      "/calendar/user-interview-schedule/",
    unregisteredUserRequestScheduleInterviewbyId:
      "/calendar/user-interview-schedule/:id/",
    getCandidateScheduledInterviewList:
      "/calendar/candidate-scheduled-interview/",

    hmsGenerateClientToken: "/hms/client-token/:id/",
    unregisterUserhmsGenerateClientToken:
      "/hms/unauthenticated-client-token/:id/",
    hmsRoomDetails: "/hms/hms-room-details/:id/",
    userPublicProfile: "/candidate/candidate-public-profile/:id/",
    getAllPublicEventLinks: "/calendar/all-event-links/:id/",

    //candidate assessment kits public
    candidatePublicAssessmentKits:
      "/interview/candidate-interviewkits-public/:id/",
    candidatePublicAssessmentKitVideos:
      "/interview/interviewkit-videos-public/:id/",

    viewMentorPublicProfile: "/mentor/mentor-public-profile/:id/",

    addHmsMeetQuestion: "/hms/meet-room-question/",
    updateHmsMeetQuestion: "/hms/meet-room-question/:id/",
    getHmsRoomQuestionsList: "/hms/meet-room-questions-list/:id/",
    hmsRoomQuestionRating: "/hms/hms-question-skill-rating/",
    updateHmsRoomQuestionRating: "/hms/hms-question-skill-rating/:id/",
    companiesList: "/users/all-company/",
    companyOverview: "/users/set-company/:id/",
    getAllAppliedCandidates: "/jobs/all-applied-candidate-list/",
    allJobs: "/jobs/all-jobs/",
    jobDetail: "/jobs/job-detail/:id/",
    companyJobsList: "/jobs/jobs-by-company/:id/",

    testQuestion: "/judge0/create-question/",
    getTestQuestion: "/judge0/get-coding-question/:id/",
    createTestQuestionSubmission: "/judge0/create-submission/",
    getTestQuestionSubmission: "/judge0/question-submission/",

    inviteCandidateToApply: "/users/candidate-invite-email/",
    inviteUserToJob: "/jobs/invite-to-job/",

    invitedJobsList: "/jobs/invited-jobs-for-candidate-list/",

    notifications: {
      jobNotifications: "/notifications/job-notifications/",
      calendarInviteNotification: "/notifications/calendar-notifications/",
      jobInviteNotifications: "/notifications/job-invite-notifications/",
    },

    // Question Bank
    quetionBank: "/search-api/search/",

    inviteCandidateToApply: "/users/candidate-invite-email/",
    inviteUserToJob: "/jobs/invite-to-job/",
    rejectJobInvitaton: "/jobs/job-invite-status/:id/",

    inviteCandidateToAseessment: "/interview/assign-interview-kit-candidate/",
    invitedAssessmentsCandidate:
      "/interview/candidate-assigned-interview-kits/",

    assignEventToJob: "/calendar/assign-event-job/",

    sendInterviewInvitationToCandidate: "/calendar/assign-event-job/",
  },

  recruiter: {
    getAllCandidate: "/users/candidate-list/",
    addCandidateProfile: "/users/create-candidate/",
    updateCandidateProfile: "/users/add-candidate-info/:id/",
    addCandidateSkills: "/candidate/add-candidate-skill/:id/",
    compileTestQuestion: "/judge0/code-compiler/",
    assignCandidateToJob: "/recruiter/job-assign/",
  },

  watcher: {
    getAllWatcherJobs: "/jobs/job-watcher/",
    inviteUser: "/jobs/invite-user-to-watch-job/",
  },

  assessmentKits: {
    assessment: "/assessment-kits/assessment/",
    getAssessments: "/assessment-kits/assessments/",
    publicDetails: "/assessment-kits/assessment-details/",
    assessmentSkill: "/assessment-kits/assessment-skill/",
    assignAassessment: "/assessment-kits/assign-assessment/",
    assignedAssessments: "/assessment-kits/assigned-assessments",
    assignedAssessment: "/assessment-kits/assigned-assessment/:id",
    candidateAssignedAssessmentDetails:
      "/assessment-kits/assigned-assessment-details/:id",
    assignedCandidates: "/assessment-kits/assigned-candidates",
    acceptAssessment: "/assessment-kits/accept-assessment",
    fetchNextQuestion: "/assessment-kits/next-question/:assessmentAssignId",
    candidateResponse:
      "/assessment-kits/save-candidate-response/:assignedQuestionId",
    assessmentAnswers:
      "/assessment-kits/saved-candidate-responses/:assessmentId/:candidateId",
    publicAssessments: "/assessment-kits/candidate-assessments/:hash_id",
    submitAssessmentKit: "/assessment-kits/submit-assessment/",
    declineAssessmentKit: "/assessment-kits/decline-assessment",

    acceptKitToReview: "/assessment-kits/accept-assessment-review/:id",
    shortlistCandidate: "/assessment-kits/shortlist-candidate-assessment/:id",
    rejectCandidate: "/assessment-kits/reject-candidate-assessment/:id",
    assessmentRevieweeRemark: "/assessment-kits/reviewee-assessment-remark/:id",
    assessmentCandidateResponseRating:
      "/assessment-kits/rate-question-response",

    skillTopics: "/master/skill-topics/:id",
    assessmentQuestion: "/assessment-kits/assessment-question/",
    allAssessmentQuestions: "/assessment-kits/assessment-questions/",
    candidateAssessments: "/assessment-kits/candidate-assessments/:hash_id/",
  },
};

const config = dev;

export default {
  ...config,
};
